var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppPagination',{staticClass:"tw-benchmark-pagination",attrs:{"total":_vm.totalCount,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"paging":_vm.onPaging}})
}
var staticRenderFns = []

export { render, staticRenderFns }